export const SET_ORDEN = "SET_ORDEN";
export const NEW_ORDEN = "NEW_ORDEN";
